import { render } from "./NotFound.vue?vue&type=template&id=5e1b2ede"
const script = {}

import exportComponent from "D:\\nodejs\\wys02\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__